import React from 'react';
import { PrimaryThemeProvider } from '@components/blocks/BlockThemeProvider';
import useTheme from '@hooks/useTheme';
import { ArrowRightIcon } from '@components/shared/V1ToV2Icon';
import ButtonWithOverflowTooltip from '../shared/ButtonWithOverflowTooltip';

interface NavMenuCardProps {
  heading: string;
  buttonText: string;
  buttonHref?: string;
  testID: string;
}

function NavMenuCard({ heading, buttonText, buttonHref, testID }: NavMenuCardProps): JSX.Element {
  const { size, font } = useTheme();

  return (
    <PrimaryThemeProvider css={{ borderRadius: size.border.radius.fiveX }}>
      <div css={{ padding: '40px 32px' }}>
        <h2
          css={{
            fontSize: font.base.size[8],
            fontWeight: font.base.weight.bold,
            lineHeight: font.lineHeight.heading,
            margin: '0px 0px 24px 0px',
            maxWidth: 224
          }}
        >
          {heading}
        </h2>
        <div css={{ maxWidth: 224 }}>
          <ButtonWithOverflowTooltip
            text={buttonText}
            icon={ArrowRightIcon}
            iconAlign="end"
            href={buttonHref}
            testID={testID}
          />
        </div>
      </div>
    </PrimaryThemeProvider>
  );
}

export default NavMenuCard;
